YP.Cashless = function() {
    return {
        init: function(){
            var cashlessPin = $('#cashless-pin');

            if(!cashlessPin.length){
                return false;
            }

            const PinStatus = {
                COMPLETE          : 'complete',
                TOO_SIMPLE        : 'too_simple',
                NOT_CORRESPONDING : 'not_corresponding',
                MUST_HAVE_4_DIGITS: 'must_have_4_digits',
                EMPTY             : 'empty'
            };

            const FeedbackMessage = {
                TOO_SIMPLE         : 'Le code PIN est trop simple',
                NOT_CORRESPONDING  : 'Les codes PIN ne correspondent pas',
                MUST_HAVE_4_DIGITS : 'Le code PIN doit contenir 4 chiffres'
            };

            function setDisabledCashlessButton() {
                $('#cashless-submit').attr('disabled', true);
                $('#cashless-submit').css('background-color', 'transparent');
                $('#cashless-submit').css('border', '2px solid #DEDEDE');
                $('#cashless-submit').css('color', '#DEDEDE');
                $('#cashless-submit').removeClass('animated pulse');
            };

            function setSuccessCashlessButton() {
                $('#cashless-submit').removeAttr('disabled');
                $('#cashless-submit').css('background-color', '#67B972');
                $('#cashless-submit').css('border', '2px solid #67B972');
                $('#cashless-submit').css('color', '#FFF');
                $('#cashless-submit').addClass('animated pulse');
            };

            function manageCashlessFeedback(show, message) {
                if (show) {
                    $('.cashless-feedback').css('display', 'block');
                    $('.cashless-feedback').text(message);
                }
                else {
                    $('.cashless-feedback').css('display', 'none');
                }
            };

            function checkPin() {

                var inputPin             = $('#cashless-pin').attr('value');
                var inputPinConfirmation = $('#cashless-pin-confirmation').attr('value');

                if (inputPin.length >= 1) {

                    if (inputPin.length == 4) {

                        var forbiddenPins = [
                            '0000',
                            '1111',
                            '2222',
                            '3333',
                            '4444',
                            '5555',
                            '6666',
                            '7777',
                            '8888',
                            '9999',
                            '1234',
                            '4321'
                        ];

                        for (var i = 0; i < forbiddenPins.length; i++) {
                            if (inputPin == forbiddenPins[i]) {
                                return PinStatus.TOO_SIMPLE;
                            }
                        }

                        if (inputPin == inputPinConfirmation) {
                            return PinStatus.COMPLETE;
                        }

                        return PinStatus.NOT_CORRESPONDING;
                    }
                    else {
                        return PinStatus.MUST_HAVE_4_DIGITS;
                    }
                }

                return PinStatus.EMPTY;
            };

            function validateKey(event) {
                var charCode = (event.which) ? event.which : event.keyCode;
                if (charCode > 31 && (charCode < 48 || charCode > 57))
                    return false;
                return true;
            };

            function toggleSubmitCashless(result){
                switch(result) {
                    case PinStatus.COMPLETE:
                        setSuccessCashlessButton();
                        manageCashlessFeedback(false);
                        break;
                    case PinStatus.TOO_SIMPLE:
                        setDisabledCashlessButton();
                        manageCashlessFeedback(true, FeedbackMessage.TOO_SIMPLE);
                        break;
                    case PinStatus.NOT_CORRESPONDING:
                        setDisabledCashlessButton();
                        manageCashlessFeedback(true, FeedbackMessage.NOT_CORRESPONDING);
                        break;
                    case PinStatus.MUST_HAVE_4_DIGITS:
                        setDisabledCashlessButton();
                        manageCashlessFeedback(true, FeedbackMessage.MUST_HAVE_4_DIGITS);
                        break;
                    default:
                        setDisabledCashlessButton();
                        manageCashlessFeedback(false);
                        break;
                }
            }
            function manageFeedback() {
                var otherValueLength = 0;
                if($(this).attr("id") === "cashless-pin"){
                    otherValueLength = $('#cashless-pin-confirmation').val().length
                }
                else{
                    otherValueLength = $('#cashless-pin').val().length
                }

                if($(this).val().length == 4 && otherValueLength == 4){
                    var result = checkPin();

                    if (result) {
                        toggleSubmitCashless(result);
                    }
                }
            };

            $('#cashless-pin').keyup(manageFeedback);

            $('#cashless-pin-confirmation').keyup(manageFeedback);

            if(cashlessPin.val().length && 
                $("#cashless-pin-confirmation").val().length){
                var result = checkPin();
                toggleSubmitCashless(result);
            }
            
            $('#cashless-pin').keypress(function(event){
                return validateKey(event);
            });

            $('#cashless-pin-confirmation').keypress(function(event){
                return validateKey(event);
            });

            $('.cashless-bind-all').on('ifChecked', function(event){
                $('.ticket-cashless-bind').hide();
            });

            $('.cashless-bind-all').on('ifUnchecked', function(event){
                $('.ticket-cashless-bind').show();
            });

            $('#check_alert_threshold').on("ifToggled", function(e){
                $("#view_alert_threshold").slideToggle(200, function(){
                    if($("#view_alert_threshold").is(":hidden")){
                        $("#view_alert_threshold .form-control").val("");
                    }
                });
            });

            $('#check_create_pin').on("ifToggled", function (e) {
                $("#view_pin").slideToggle(200, function() {
                    if($("#view_pin").is(":hidden")) {
                        $("#view_pin .form-control").val("");
                        setSuccessCashlessButton();
                    }
                    else {
                        setDisabledCashlessButton();
                    }
                });
            });

            if($('#check_create_pin').prop('checked')) {
                $("#view_pin").slideToggle(200, function() {
                    if($("#view_pin").is(":hidden")) {
                        $("#view_pin .form-control").val("");
                        $('.cashless-feedback').css('display', 'none');
                        setSuccessCashlessButton();
                    }
                    else {
                        setDisabledCashlessButton();
                    }
                });
            }

            if($('#check_alert_threshold').prop('checked')) {
                $("#view_alert_threshold").slideToggle(200, function () {});
            }
        }
    };
};

window.addEventListener("load", function(){
    YP.Cashless().init();
});
